import { GET_IDFC_MAIL_WEBHOOK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const getIdfcMailWebhook = (payload) => {
  return apiInstance.post(GET_IDFC_MAIL_WEBHOOK, payload);
};
